export const ERROR_NOTIFICATIONS_CONTENT = {
    COOKIE_BOT: "Nie udało się otworzyć okna ustawień cookies, spróbuj później",
    DEFAULT_API: "Coś poszło nie tak. Spróbuj później.",
    PHONE: "Nieprawidłowy numer telefonu"
} as const;
export const ERROR_NOTIFICATIONS_CONTENT = {
    COOKIE_BOT: "Nie udało się otworzyć okna ustawień cookies, spróbuj później",
    DEFAULT_API: "Coś poszło nie tak. Spróbuj później.",
    PHONE: "Nieprawidłowy numer telefonu"
} as const;
